// preview 專用：館藏查詢頁「新版」（Phase 2）。掛在隱藏 route /library_preview/search。
// 依前面 4-tab 所選 tab 設定「預設檢索範圍(scope)」，頁內仍可切換：
//   整合查詢 integrated → 紙本館藏 + 電子資源（分區塊）
//   資料庫查詢 database  → 電子資源瀏覽器
//   館藏書籍 collection  → 原本紙本書目（重用 BibSearchFunction，不動原檔）
//   試用資料庫 trial     → 電子資源瀏覽器（僅試用）
// 原始 /library/.../bib_search_function 完全不動。
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import BibSearchFunction from "../../online_public_catalog_query_construction/views/bib_search_function";
import EResourceBrowser from "./eresource_browser";

const SCOPES = [
  { key: "integrated", label: "整合查詢" },
  { key: "database", label: "資料庫查詢" },
  { key: "collection", label: "館藏書籍" },
  { key: "trial", label: "試用資料庫" },
];
const tabToScope = (t) => (SCOPES.find((s) => s.key === t) ? t : "integrated");

const SectionTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 800;
  color: #1e3a8a;
  margin: 1.25rem 0 0.75rem;
  padding-left: 0.55rem;
  border-left: 5px solid #fa8c16;
`;

const PreviewCatalog = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "integrated";
  const kw = searchParams.get("search") || "";
  const [scope, setScope] = useState(tabToScope(tab));

  useEffect(() => {
    setScope(tabToScope(tab));
  }, [tab]);

  const BookPanel = (
    <BibSearchFunction prefixRoute="/library/online_public_catalog_query_construction" />
  );

  return (
    <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "1.25rem 1rem 3rem" }}>
      <h2 style={{ fontSize: "1.6rem", fontWeight: 800, color: "#1e3a8a", marginBottom: "1rem" }}>
        館藏 · 電子資源查詢
      </h2>

      {/* 檢索範圍切換（預設由前面 tab 帶入） */}
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "0.5rem" }}>
        {SCOPES.map((s) => {
          const on = s.key === scope;
          return (
            <button
              key={s.key}
              type="button"
              onClick={() => setScope(s.key)}
              style={{
                padding: "0.5rem 1.15rem",
                borderRadius: "999px",
                border: on ? "none" : "1px solid #c7d2fe",
                background: on ? "linear-gradient(90deg,#1e3a8a,#2563eb)" : "#fff",
                color: on ? "#fff" : "#1e3a8a",
                fontWeight: 700,
                fontSize: "0.9rem",
                cursor: "pointer",
                boxShadow: on ? "0 3px 10px rgba(37,99,235,0.3)" : "none",
              }}
            >
              {s.label}
            </button>
          );
        })}
      </div>
      {kw && (
        <div style={{ color: "#64748b", fontSize: "0.85rem", marginBottom: "0.5rem" }}>
          關鍵字：<b>{kw}</b>
        </div>
      )}

      {/* 依 scope 呈現 */}
      {scope === "collection" && <div style={{ marginTop: "0.75rem" }}>{BookPanel}</div>}

      {scope === "database" && (
        <div style={{ marginTop: "0.75rem" }}>
          <EResourceBrowser initialKeyword={kw} />
        </div>
      )}

      {scope === "trial" && (
        <div style={{ marginTop: "0.75rem" }}>
          <EResourceBrowser initialKeyword={kw} trialOnly />
        </div>
      )}

      {scope === "integrated" && (
        <>
          <SectionTitle>紙本館藏</SectionTitle>
          {BookPanel}
          <SectionTitle>電子資源</SectionTitle>
          <EResourceBrowser initialKeyword={kw} />
        </>
      )}
    </div>
  );
};

export default PreviewCatalog;
